import React from 'react'

const Flexbox_Coding_Assignment_1 = () => {
  return (
    <div>
      <h1>Coding Assignment 1</h1>
    </div>
  )
}

export default Flexbox_Coding_Assignment_1
